import {Component, Inject, OnInit} from '@angular/core';
import {
  AbstractControl, FormArray,
  FormControl,
  FormGroup,
  Validators,
  ɵFormGroupRawValue,
  ɵGetProperty,
  ɵTypedOrUntyped
} from '@angular/forms';
import {EducationService} from '../../education.service';
import {Centre} from "../../../../interfaces/Centres";
import {Observable} from "rxjs";
import {FullChild} from "../../../../interfaces/FullChild";
import {CentreService} from "../../../../services/centre.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ChildService} from "../../../../components/child/child.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AddIdividualEducationComponent} from "../add-idividual-education/add-idividual-education.component";
import {MatSelectChange} from "@angular/material/select";
import firebase from "firebase/compat";
import Timestamp = firebase.firestore.Timestamp;
import {LogService} from "../../../../services/log.service";

@Component({
  selector: 'app-edit-individual-education',
  templateUrl: './edit-individual-education.component.html',
  styleUrls: ['./edit-individual-education.component.scss']
})
export class EditIndividualEducationComponent implements OnInit {
  centres$: Observable<Centre[]>
  docpath = 'educationTest/'
  dbType: any = 'firestore'
  formSaved = false
  userData = JSON.parse(localStorage.getItem('userData')!)
  storagePath = 'EducationDocs'
  children$?: Observable<FullChild[]>
  selectedCentreCode!: string
  selectedCentreName!: string
  startTimeValue: any
  endTimeValue: any
  centreSelect: FormControl = new FormControl('', Validators.required)
  childSelect: FormControl = new FormControl('', Validators.required)
  childGender = ''
  form!: FormGroup
  private languagePercentage = 0;
  private mathsPercentage = 0;
  private evsgkPercentage = 0;
  initialFormState: any; //?add this


  constructor(readonly centreService: CentreService,
              readonly eduationService: EducationService,
              readonly matSnackBar: MatSnackBar,
              private readonly mLogService:LogService,

              readonly childService: ChildService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              readonly mDialogRef:MatDialogRef<EditIndividualEducationComponent>) {
    this.centres$ = centreService.getAllCentres()
  }


  ngOnInit(): void {
    this.initForm()
    this.initialFormState = deepCloneFormState(this.form);

  }

  private initForm() {
    console.log(this.data)
    let submittedBy = this.data.submittedBy
    this.form = new FormGroup({
      centreName: new FormControl(this.data.centreName, Validators.required),
      centreCode: new FormControl(this.data.centreCode, Validators.required),
      childName: new FormControl(this.data.childName, Validators.required),
      childCode: new FormControl(this.data.childCode, Validators.required),
      sessionType: new FormControl({value:this.data.sessionType,disabled:true}, Validators.required),

      languageLevel: new FormControl(this.data.languageLevel, baselineRequiredValidator),
      languageOral: new FormControl(this.data.languageOral, baselineRequiredValidator),
      languageWritten: new FormControl(this.data.languageWritten, baselineRequiredValidator),
      languagePercentage: new FormControl(this.data.languagePercentage, baselineRequiredValidator),

      mathsLevel: new FormControl(this.data.mathsLevel, baselineRequiredValidator),
      mathsOral: new FormControl(this.data.mathsOral, baselineRequiredValidator),
      mathsWritten: new FormControl(this.data.mathsWritten, baselineRequiredValidator),
      mathsPercentage: new FormControl(this.data.mathsPercentage, baselineRequiredValidator),
      conductedBy:new FormControl(this.data?.conductedBy,Validators.required),


      evsgkLevel: new FormControl(this.data.evsgkLevel, baselineRequiredValidator),
      evsgkWritten: new FormControl(this.data.evsgkWritten, baselineRequiredValidator),
      evsgkOral: new FormControl(this.data.evsgkOral, baselineRequiredValidator),
      evsgkPercentage: new FormControl(this.data.evsgkPercentage, baselineRequiredValidator),



      gender: new FormControl(this.data.gender, Validators.required),
      sessionDate: new FormControl(this.checkDate((this.data?.sessionDate)), Validators.required),
      // sessionDate: new FormControl('', Validators.required),
      topicsCovered: new FormControl(this.data.topicsCovered, Validators.required),
      present: new FormControl(this.data.present, Validators.required),
      subject: new FormControl(this.data.subject, Validators.required),
      sessionDetails: new FormControl(this.data.sessionDetails, Validators.required),
      remark: new FormControl(this.data.remark, Validators.required),
      // startTime: new FormControl(this.checkDate(this.data?.startTime), Validators.required),
      startTime: new FormControl(''),
      volunteerName: new FormControl(this.data.volunteerName),
      // endTime: new FormControl((this.data?.endTime as Timestamp).toDate(), Validators.required),
      endTime: new FormControl('', Validators.required),
      submittedBy: new FormControl({value:submittedBy,disabled:true}),
      edittedBy: new FormControl({value: this.userData.userName, disabled: true}),
      // createdAt: new FormControl((this.data.createdAt as Timestamp).toDate()),

      updatedAt: new FormControl(new Date()),
      unitCode: new FormControl(this.data?.unitCode, Validators.required),
      absentReason: new FormControl(this.data?.absentReason, absentConditionallyRequiredValidator),
      followUpChild: new FormControl(this.data?.followUpChild, Validators.required)
    })
    if(this.data.startTime != undefined && this.data.startTime != null ){
      this.form.get('startTime')?.setValue(this.checkDate(this.data.startTime))
    }
    if(this.data.endTime != null && this.data.endTime != undefined){
      this.form.get('endTime')?.setValue(this.checkDate(this.data.endTime))
    }
    this.form.get('centreName')?.disable()
    this.form.get('childName')?.disable()
    this.form.get('unitCode')?.disable()
    this.form.get('gender')?.disable()
    if(this.data.sessionType=='Rapport Building'){
      this.form.get('remark')?.disable()
      this.form.get('sessionDetails')?.disable()
    }
    // this.form.get('gender')?.disable()
    if (this.data.present != 'Present') {
      this.startTime?.disable()
      this.endTime?.disable()
      this.endTime?.disable()
      this.Subject?.disable()
      this.TopicsCovered?.disable()
      this.form.get('remark')?.disable()

      this.form.get('sessionType')?.disable()
      this.form.get('topicsCovered')?.disable()
      this.TopicsCovered?.disable()

    } else {
      this.startTime?.enable()
      this.endTime?.enable()
      this.endTime?.enable()
      this.Subject?.enable()
if(this.data.sessionType!='Rapport Building')       this.TopicsCovered?.enable()
if(this.data.sessionType!='Rapport Building')       this.form.get('remark')?.enable()


      this.form.get('sessionType')?.disable()
      this.form.get('sessionDetails')?.enable()
    }
    if(this.data.sessionType=='Rapport Building')       this.TopicsCovered?.disable()
    if(this.data.sessionType=='Rapport Building')       this.form.get('remark')?.disable()
  }

  onCentreSelect($event: any) {
    this.selectedCentreCode = $event.value.centreCode
    this.selectedCentreName = $event.value.centreName
    this.children$ = this.childService.getAllotedChildListByCenterAboveThree(this.selectedCentreCode)
    this.CenterName?.setValue($event.value.centreName)
    this.CentreCode?.setValue(this.selectedCentreCode)
  }

  onChildSelect($event: MatSelectChange) {
    let selectedChild = $event.value as FullChild
    this.form.get('gender')?.setValue({value: selectedChild.gender, disabled: true})
    this.ChildGender?.setValue(selectedChild.gender)
    this.ChildName?.setValue(`${selectedChild.firstName} ${selectedChild.lastName}`)
    this.ChildCode?.setValue(selectedChild.childCode)
    this.ChildUnit?.setValue(selectedChild.selectUnit)
    this.ChildUnit?.disable()
  }

  get startTime() {
    return this.form.get('startTime')
  }

  get ChildUnit() {
    return this.form.get('unitCode')
  }

  get endTime() {
    return this.form.get('endTime')
  }

  get unitCode() {
    return this.form.get('unitCode')
  }

  get ChildGender() {
    return this.form.get('gender')
  }

  get ChildName() {
    return this.form.get('childName')
  }

  get ChildCode() {
    return this.form.get('childCode')
  }

  get CenterName() {
    return this.form.get('centreName')
  }

  get CentreCode() {
    return this.form.get('centreCode')
  }

  get Subject() {
    return this.form.get('subject')
  }

  get TopicsCovered() {
    return this.form.get('topicsCovered')
  }
  get TypeOfSession() {
    return this.form.get('sessionType')
  }

  Submit() {
    if (this.form.valid) {
      const submittedFormState: any = this.form; //?add this



      if(this.TypeOfSession?.value!='Baseline Assessment' && this.TypeOfSession?.value != 'Discharge Assessment')
      {
        this.form.removeControl('languageLevel')
        this.form.removeControl('languageOral')
        this.form.removeControl('languageWritten')
        this.form.removeControl('languagePercentage')
        this.form.removeControl('mathsLevel')
        this.form.removeControl('mathsOral')
        this.form.removeControl('mathsWritten')
        this.form.removeControl('mathsPercentage')
        this.form.removeControl('evsgkLevel')
        this.form.removeControl('evsgkWritten')
        this.form.removeControl('evsgkOral')
        this.form.removeControl('evsgkPercentage')
      }
      if(this.TypeOfSession?.value== 'Discharge Assessment'){
        this.form.removeControl('languageLevel')
        this.form.removeControl('evsgkLevel')
        this.form.removeControl('mathsLevel')

      }

      if(this.form.get('present')?.value =='Absent'){
        this.startTime?.setValue('')
        this.endTime?.setValue('')

        this.Subject?.setValue('')
        this.TopicsCovered?.setValue('')
        this.form.get('sessionType')?.setValue('')
        this.form.get('sessionDetails')?.setValue('')
      }
      this.eduationService.updateIndividualSession(this.form.getRawValue(),this.data.id)
        .then(response => {
        this.formSaved = false

        this.matSnackBar.open('Updated Successfully! ')._dismissAfter(3000)
          const differences = this.getFormDifference(this.initialFormState, submittedFormState)
          let activity={
            date:new Date().getTime(),
            section: 'Individual Education',
            action: 'Update',
            changes: differences,  //?add this
            description: `Session for ${this.form.get('childCode')?.value} ${this.form.get('childName')?.value} Updated to Education by` ,
            currentIp: localStorage.getItem('currentip')!
          }
          this.mLogService.addLog(activity)
        this.mDialogRef.close()
      })
    } else alert('Please enter all fields carefully!!!')


  }

  getFormDifference(initialFormState: any, submittedFormState: any) {
    const differences: any = {};

    for (const key in this.initialFormState.controls) {
      const initialControl = this.initialFormState.get(key);
      const submittedControl = submittedFormState.get(key);

      if (initialControl instanceof FormArray && submittedControl instanceof FormArray) {
        for (let i = 0; i < initialControl.length; i++) {
          if (!isEqualValue(initialControl.at(i).value, submittedControl.at(i).value)) {
            if (!differences[key]) {
              differences[key] = [];
            }
            differences[key].push({
              index: i,
              initialValue: initialControl.at(i).value,
              submittedValue: submittedControl.at(i).value,
            });
          }
        }
      } else if (!isEqualValue(initialControl?.value, submittedControl?.value)) {
        differences[key] = {
          initialValue: initialControl?.value,
          submittedValue: submittedControl?.value,
        };
      }
    }

    return differences;
  }


  onAttendaceSelect($event: MatSelectChange) {
    let attendance = $event.value
    if (attendance == 'Absent') {
      this.startTime?.disable()
      this.endTime?.disable()
      this.endTime?.disable()
      this.Subject?.disable()
      this.TopicsCovered?.disable()
      this.form.get('sessionType')?.disable()
      this.form.get('sessionDetails')?.disable()
    } else {
      this.startTime?.enable()
      this.endTime?.enable()
      this.endTime?.enable()
      this.Subject?.enable()
 if(this.TypeOfSession?.value!='Rapport Building')     this.TopicsCovered?.enable()
 if(this.TypeOfSession?.value!='Rapport Building')     this.form.get('remark')?.enable()

      // this.form.get('sessionType')?.enable()
      this.form.get('sessionDetails')?.enable()
    }

  }

  close(){
    this.mDialogRef.close()
  }

  private checkDate(date: any) {
    let d:any=''
    if(date!=null){
      d=(date as Timestamp).toDate()
    }
    else d=null
    return d
  }

  getLanguagePerc(value1: ɵGetProperty<ɵTypedOrUntyped<any, ɵFormGroupRawValue<any>, any>, "languageOral"> | undefined, value2: ɵGetProperty<ɵTypedOrUntyped<any, ɵFormGroupRawValue<any>, any>, "languageWritten"> | undefined) {
    if (value1 != null && value2 != null) {
      this.languagePercentage = (((value1 / 20 + value2 / 20)) * 100)
      this.form.get('languagePercentage')?.setValue(this.languagePercentage)

      return (((value1 / 20 + value2 / 20)) * 100)
    }
    return 0
  }

  getMathsPercentage(value1: ɵGetProperty<ɵTypedOrUntyped<any, ɵFormGroupRawValue<any>, any>, "mathsOral"> | undefined, value2: ɵGetProperty<ɵTypedOrUntyped<any, ɵFormGroupRawValue<any>, any>, "mathsWritten"> | undefined) {
    if (value1 != null && value2 != null) {
      this.mathsPercentage = (((value1 / 20 + value2 / 20)) * 100)
      this.form.get('mathsPercentage')?.setValue(this.mathsPercentage)

      return  this.mathsPercentage
    }
    return 0
  }
  onSessionTypeSelect($event:any): void {
    const selectedSessionType = this.form.get('sessionType')?.value;
    const subjectControl = this.form.get('remark');
    const topicControl = this.form.get('topicsCovered');

    if (selectedSessionType === 'Rapport Building') {
      console.log("here")
      console.log("here2")
      this.form.get('subject')?.disable();
      this.form.get('remark')?.disable();
      this.form.get('topicsCovered')?.disable();
    }

    else {
      subjectControl?.enable();
      topicControl?.enable();
    }
  }


  getEvsGKPercentage(value1: ɵGetProperty<ɵTypedOrUntyped<any, ɵFormGroupRawValue<any>, any>, "evsgkOral"> | undefined, value2: ɵGetProperty<ɵTypedOrUntyped<any, ɵFormGroupRawValue<any>, any>, "evsgkWritten"> | undefined) {
    if (value1 != null && value2 != null) {
      this.evsgkPercentage = (((value1 / 20 + value2 / 20)) * 100)
      this.form.get('evsgkPercentage')?.setValue(this.evsgkPercentage)

      return (((value1 / 20 + value2 / 20)) * 100)
    }
    return 0

  }



  onSessionSelect($event: MatSelectChange) {


      if(this.TypeOfSession?.value!='Baseline Assessment'){
        this.form.removeControl('languageLevel')
        this.form.removeControl('languageOral')
        this.form.removeControl('languageWritten')
        this.form.removeControl('languagePercentage')

        this.form.removeControl('mathsLevel')
        this.form.removeControl('mathsOral')
        this.form.removeControl('mathsWritten')
        this.form.removeControl('mathsPercentage')

        this.form.removeControl('evsgkLevel')
        this.form.removeControl('evsgkWritten')
        this.form.removeControl('evsgkOral')
        this.form.removeControl('evsgkPercentage')

      }
      else{
        this.form.addControl('languageLevel', new FormControl('', Validators.required));
        this.form.addControl('languageOral', new FormControl('', Validators.required));
        this.form.addControl('languageWritten', new FormControl('', Validators.required));
        this.form.addControl('languageWritten', new FormControl('', Validators.required));


        this.form.addControl('mathsLevel', new FormControl('', Validators.required));
        this.form.addControl('mathsOral', new FormControl('', Validators.required));
        this.form.addControl('mathsWritten', new FormControl('', Validators.required));
        this.form.addControl('mathsPercentage', new FormControl('', Validators.required));

        this.form.addControl('evsgkLevel', new FormControl('', Validators.required));
        this.form.addControl('evsgkWritten', new FormControl('', Validators.required));
        this.form.addControl('evsgkOral', new FormControl('', Validators.required));
        this.form.addControl('evsgkPercentage', new FormControl('', Validators.required));


      }

  }
}



function absentConditionallyRequiredValidator(formControl: AbstractControl) {
  if (!formControl.parent) {
    return null;
  }

  if (formControl.parent.get('present')?.value == 'Absent') {
    return Validators.required(formControl);
  }
  return null;
}
function baselineRequiredValidator(formControl: AbstractControl) {
  if (!formControl.parent) {
    return null;
  }

  if (formControl.parent.get('sessionType')?.value == 'Baseline Assessment') {
    return Validators.required(formControl);
  }
  return null;
}
// Function to validate controls based on the value of 'typeOfSession'

/**
 * Deep clones form state without using lodash
 */
function deepCloneFormState(form: FormGroup): any {
  const clonedControls: { [key: string]: any } = {};

  Object.keys(form.controls).forEach(key => {
    const control = form.get(key);
    if (control instanceof FormGroup) {
      clonedControls[key] = deepCloneFormState(control);
    } else if (control instanceof FormArray) {
      clonedControls[key] = control.controls.map(c => c.value);
    } else {
      clonedControls[key] = control?.value;
    }
  });

  return clonedControls;
}

/**
 * Compares two values deeply without using lodash
 */
function isEqualValue(val1: any, val2: any): boolean {
  if (val1 === val2) return true;
  if (typeof val1 !== typeof val2) return false;
  if (typeof val1 !== 'object') return false;
  if (Array.isArray(val1) !== Array.isArray(val2)) return false;

  if (Array.isArray(val1)) {
    if (val1.length !== val2.length) return false;
    return val1.every((item, index) => isEqualValue(item, val2[index]));
  }

  const keys1 = Object.keys(val1);
  const keys2 = Object.keys(val2);
  if (keys1.length !== keys2.length) return false;

  return keys1.every(key => isEqualValue(val1[key], val2[key]));
}
